import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Select, Input, Button, Icon, Checkbox, message } from 'antd';
import TableC from '../../../basicElement/TableC';
import Text from '../../../basicElement/Text';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';
import { RelateType } from '../constants';
import renderEnhancer from '../../../shared/renderEnhancer';

const { Option } = Select;

const genOptions = data => Object.keys(data).map(i => <Option key={i} value={i}>{ data[i] }</Option>);

const RelateTypeOption = genOptions(RelateType);

class BatchRelate extends Component {
    static contextTypes = {
        contractList: PropTypes.array,
    }

    state = {
        visible: false,
        loading: false,
        pagination: { current: 1 },
        data: [],
        filterDropdownVisible: false,
        searchText: '',
        filtered: false,
    }

    data = []

    centerList = []

    loadCenter = () => {
        this.setState({ loading: true });
        const options = {
            url: API_URL.site.list,
            data: { limit: 9999 },
            dataType: 'json',
            doneResult: res => {
                const { siteList } = res.data;
                const { datas } = siteList || {};
                this.centerList = datas;
                this.data = this.genData();
                this.setState({ loading: false }, () => {
                    this.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    show = () => {
        this.setState({ visible: true }, () => {
            this.loadCenter();
        });
    }

    hide = () => {
        this.data = [];
        this.centerList = [];
        this.setState({
            data: [],
            pagination: { current: 1 },
            visible: false,
            filterDropdownVisible: false,
            searchText: '',
            filtered: false,
        });
    }

    /**
     * 1. 根据当前页，显示对应的JDE
     * 2. 过滤出和筛选条件匹配的数据
     */
    loadData = () => {
        const { contractList } = this.context;
        const { filtered, searchText, pagination } = this.state;
        const { investigationJdeContractId } = contractList[pagination.current - 1] || {};
        let data = this.data.filter(i => i.investigationJdeContractId === investigationJdeContractId);
        data = data.filter(i => filtered ? i.investigationSite.includes(searchText) : true);
        this.setState({ data });
    }

    genData = () => {
        const centerList = this.centerList;
        const { contractList } = this.context;

        // 构建一个合同到多个中心的集合
        const contractToCenters = {};
        centerList.forEach(center => {
            const { investigationSiteId, contractVos } = center;
            (contractVos || []).forEach(contract => {
                const { relatedType, investigationJdeContractId } = contract;
                if (!contractToCenters[investigationJdeContractId]) {
                    contractToCenters[investigationJdeContractId] = {};
                }
                contractToCenters[investigationJdeContractId][investigationSiteId] = relatedType;
            });
        });

        const data = [];
        const len = centerList.length;
        (contractList || []).forEach(contract => {
            const { investigationJdeContractId, investigationJdeContractCode, contractType } = contract;
            const centers = contractToCenters[investigationJdeContractId] || {};
            centerList.forEach((center, index) => {
                const { investigationSiteId, investigationSiteName, investigationSiteCode } = center;
                if (index === 0) {
                    data.push({
                        investigationJdeContractId,
                        investigationJdeContractCode,
                        investigationSite: '所有中心',
                        start: 0,
                        last: len,
                    });
                }
                const relatedType = centers[investigationSiteId];
                data.push({
                    investigationJdeContractId,
                    investigationJdeContractCode,
                    investigationSiteId,
                    investigationSite: `${investigationSiteName}（${investigationSiteCode}）`,
                    contractType,
                    relatedType,
                    checked: !!relatedType,
                });
            });
        });

        return data;
    }

    onInputChange = (e) => {
        this.setState({ searchText: e.target.value });
    }

    search = () => {
        const { searchText } = this.state;
        this.setState({
            filterDropdownVisible: false,
            filtered: !!searchText,
        }, () => {
            this.loadData();
        });
    }

    cancel = () => {
        this.setState({
            searchText: '',
            filterDropdownVisible: false,
            filtered: false,
        }, () => {
            this.loadData();
        });
    }

    onFilterDropdownVisibleChange = (visible) => {
        this.setState({
            filterDropdownVisible: visible,
        }, () => this.searchInput.focus());
    }

    handleChange = (value, index, key) => {
        const { data } = this.state;
        const item = data[index]
        const { investigationSiteId, start, last } = item;
        item[key] = value;
        if (key === 'checked' && !value) {
            item.relatedType = undefined;
        }
        if (!investigationSiteId) {
            for (let i = start + 1; i <= last; i++) {
                data[i][key] = value;
                if (key === 'checked' && !value) {
                    data[i].relatedType = undefined;
                }
            }
        }
        this.setState({ data });
    }

    handleSelectAll = (e) => {
        const { data } = this.state;
        const checked = e.target.checked;
        data.forEach(i => i.checked = checked);
        this.setState({ data });
    }

    getColumns = () => {
        const { data, searchText, filtered, filterDropdownVisible } = this.state;
        const selectAll = data.length ? data.every(i => i.checked) : false;
        const columns = [{
            title: 'JDE项目号',
            dataIndex: 'investigationJdeContractCode',
            key: 'investigationJdeContractCode',
            width: 100,
            render: renderEnhancer()
        }, {
            title: '合同主键',
            dataIndex: 'investigationJdeContractId',
            key: 'investigationJdeContractId',
            width: 80,
            render: renderEnhancer()
        }, {
            title: (
                <div>
                    <Checkbox style={{ marginRight: 4 }} checked={selectAll} onChange={this.handleSelectAll} />
                    全选
                </div>
            ),
            dataIndex: 'index',
            key: 'index',
            width: 60,
            render: (text, record, index) => {
                let { checked, investigationSiteId, start, last } = record;
                // 所有中心
                if (!investigationSiteId) {
                    for (let i = start + 1; i <= last; i++) {
                        checked = checked ? data[i].checked : false;
                    }
                }
                return (
                    <div style={{ textAlign: 'center' }}>
                        <Checkbox checked={checked} onChange={e => this.handleChange(e.target.checked, index, 'checked')} />
                    </div>
                );
            }
        }, {
            title: '中心名称(中心编号)',
            dataIndex: 'investigationSite',
            key: 'investigationSite',
            width: 340,
            filterDropdown: (
                <div className="custom-filter-dropdown">
                    <Input
                        ref={el => this.searchInput = el}
                        placeholder="请输入"
                        value={searchText}
                        style={{ width: 130 }}
                        onChange={this.onInputChange}
                        onPressEnter={this.search}
                    />
                    <Button type="primary" style={{ marginLeft: 8 }} onClick={this.search}>搜索</Button>
                    <Button type="primary" style={{ marginLeft: 8 }} onClick={this.cancel}>取消</Button>
                </div>
              ),
            filterIcon: <Icon type="filter" style={{ color: filtered ? '#108ee9' : '#aaa' }} />,
            filterDropdownVisible: filterDropdownVisible,
            onFilterDropdownVisibleChange: this.onFilterDropdownVisibleChange,
        }, {
            title: <Text asterisk={true} colon={false}>关联类型</Text>,
            dataIndex: 'relatedType',
            key: 'relatedType',
            width: 100,
            render: (text, record, index) => {
                let { checked, relatedType, investigationSiteId, start, last } = record;
                // 所有中心
                if (!investigationSiteId) {
                    for (let i = start + 1; i <= last; i++) {
                        checked = checked ? data[i].checked : false;
                    }
                }
                return (
                    <Select
                        disabled={!checked}
                        allowClear={true}
                        placeholder="请选择"
                        style={{ width: 80 }}
                        value={checked ? relatedType : undefined}
                        onChange={value => this.handleChange(value, index, 'relatedType')}
                    >
                        { RelateTypeOption }
                    </Select>
                )
            }
        }];
        return columns;
    }

    getDataSource = () => {
        const { data } = this.state;
        let len = data.length;
        let previousId = null;
        return data.map((item, index) => {
            const { investigationJdeContractId } = item;
            // 合并相同合同行
            if (!previousId || previousId !== investigationJdeContractId) {
                previousId = investigationJdeContractId;
                // 查找不同合同的index
                const nextId = data.findIndex((i, j) => j > index && i.investigationJdeContractId !== investigationJdeContractId);
                // 计算出要合并的行数
                item.rowSpan = nextId >= 0 ? nextId - index : len - index;
            } else {
                item.rowSpan = 0;
            }
            return item;
        });
    }

    handleTableChange = (params) => {
        this.setState(params, () => {
            this.loadData();
        });
    }

    confirm = () => {
        const data = this.data;
        const params = {};

        let index = 0;
        for (let i = 0, len = data.length; i < len; i++) {
            const { checked, relatedType, contractType, investigationJdeContractId, investigationSiteId } = data[i];

            if (investigationSiteId && checked) {
                if (!relatedType) {
                    return message.warning('请选择关联类型！');
                }
                params[`contractSites[${index}].relatedType`] = relatedType;
                params[`contractSites[${index}].contractType`] = contractType;
                params[`contractSites[${index}].investigationJdeContractId`] = investigationJdeContractId;
                params[`contractSites[${index}].investigationSiteId`] = investigationSiteId;
                index++;
            }
        }

        this.setState({ loading: true });
        const options = {
            url: API_URL.site.batchRelatedSiteAndContractById,
            data: params,
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.hide();
                this.setState({ loading: false }, () => {
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    render() {
        const { contractList } = this.context;
        let { visible, loading, pagination } = this.state;
        const data = this.getDataSource();
        const pageSize = data.length;
        pagination = {
            ...pagination,
            pageSize,
            total: pageSize * contractList.length
        };
        return (
            <Modal
                title="中心-合同批量关联"
                visible={visible}
                onCancel={this.hide}
                onOk={this.confirm}
                bodyStyle={{ maxHeight: 500 }}
                confirmLoading={loading}
                maskClosable={false}
                width="790px"
            >
                <div style={{ padding: 10 }}>
                    <TableC
                        columns={this.getColumns()}
                        data={data}
                        loading={loading}
                        className="batchRelate"
                        scrollY={340}
                        pagination={pagination}
                        onChange={this.handleTableChange}
                    />
                </div>
            </Modal>
        );
    }
}

export default BatchRelate;


// WEBPACK FOOTER //
// ./src/components/site/researchCenterDetail/components/BatchRelate.js